<template>
  <div class="about-page">
    <section class="page-hero page-hero--about">
      <div class="page-hero__shade"></div>
      <div class="site-shell page-hero__content">
        <p class="eyebrow">ABOUT JADE ARTISAN</p>
        <h1>关于玉雕匠人</h1>
        <p>敬畏材料，尊重手艺，长期记录玉雕文化的当代表达。</p>
      </div>
    </section>

    <section class="about-intro">
      <div class="site-shell about-intro__grid">
        <div class="about-intro__title">
          <p class="eyebrow">OUR PURPOSE</p>
          <h2>让好手艺被看见，也让每件作品有据可查</h2>
        </div>
        <div class="about-intro__copy">
          <div v-if="describe" class="rich-text" v-html="describe"></div>
          <p v-else>玉雕匠人专注于匠人、作品与证书档案的整理和展示，以清晰可信的方式连接创作者、收藏者与玉雕爱好者。</p>
          <p>我们相信，真正经得住时间的价值，来自对材料的理解、对技艺的坚持，以及对每一件作品来历的认真记录。</p>
        </div>
      </div>
    </section>

    <section class="about-mission">
      <div class="site-shell about-mission__inner">
        <div class="about-mission__statement">
          <p class="eyebrow">OUR MISSION</p>
          <blockquote>传承中华玉石文化，推广玉雕艺术，连接匠人与爱好者。</blockquote>
        </div>
        <div class="about-mission__mark">玉</div>
      </div>
    </section>

    <section class="about-values">
      <div class="site-shell">
        <header class="editorial-heading">
          <div>
            <p class="eyebrow">OUR VALUES</p>
            <h2>我们坚持的事</h2>
          </div>
          <p>专业、诚信、品质与服务，是平台长期运营的基本准则。</p>
        </header>
        <div class="value-list">
          <article v-for="value in coreValues" :key="value.title" class="value-item">
            <i :class="value.icon"></i>
            <div><h3>{{ value.title }}</h3><p>{{ value.desc }}</p></div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getCompanyProfile } from '@/api/home'

export default {
  name: 'AboutPage',
  data() {
    return {
      describe: '',
      coreValues: [
        { icon: 'el-icon-medal', title: '专业', desc: '持续整理玉雕行业资料，以专业标准呈现匠人与作品档案。' },
        { icon: 'el-icon-document-checked', title: '诚信', desc: '重视作品来源与证书核验，让公开信息清晰、可信、可追溯。' },
        { icon: 'el-icon-star-off', title: '品质', desc: '尊重材料与创作，只展示经得住细看与时间检验的作品。' },
        { icon: 'el-icon-service', title: '服务', desc: '站在匠人、收藏者与爱好者的角度，提供简明顺畅的服务。' }
      ]
    }
  },
  created() {
    getCompanyProfile().then(res => {
      this.describe = res.msg || ''
    }).catch(error => {
      console.error('获取平台介绍失败:', error)
    })
  }
}
</script>
